module.exports = __webpack_public_path__ + "img/sampdoria.88bf9be1.png";